<template>
    <div>
        <div v-if="$store.state.settings.mode ==='pc'" class="main">
            <Nav :title="state" />
            <div class="container">
                <div class="center-big-box">
                    <ul>
                        <li v-for="(item, index) in downList" :key="index">
                            <span>{{ item.edittime | capitalize }} <i>{{ item.edittime | capitalizes }}-{{ item.edittime | capitalizec }}</i> </span>
                            <div class="title">
                                <h4>{{ item.name }}</h4>
                            </div>
                            <div class="downBtn">
                                <a :href="item.file" target="_blank">下载</a>
                            </div>
                        </li>
                    </ul>
                    <div class="block">
                        <el-pagination
                            :page-size="5"
                            layout="total, prev, pager, next, jumper"
                            :total="total"
                            background
                            :hide-on-single-page="value"
                            @current-change="handleCurrentChange"
                        />
                    </div>
                </div>
                <NewsPolicies :policies-name="policiesName" :data-list="NewsdataList" class="right-box" />
            </div>
        </div>
        <div v-else class="mobileMain">
            <div class="head">
                <img src="../../../assets/images/index/zjt.png" alt="" @click="fallback">
                <div>申请表下载</div>
            </div>
            <ul>
                <li v-for="(item, index) in downList" :key="index">
                    <div style="flex:1;">
                        <div class="title">
                            {{ item.name }}
                        </div>
                        <div class="time">{{ item.edittime | capitalize }}-{{ item.edittime | capitalizes }}-{{ item.edittime | capitalizec }}</div>
                    </div>
                    <div class="downBtn">
                        <a :href="item.file" target="_blank">下载</a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import 'swiper/css/swiper.css'
import Nav from '@/layout/nav'
import NewsPolicies from '@/layout/policies/newsPolicies'
export default {
    components: {
        Nav,
        NewsPolicies
    },
    filters: {
        capitalize: function(value) {
            if (!value) return ''
            value = value.trim().split('-')
            return value[0]
        },
        capitalizes: function(value) {
            if (!value) return ''
            value = value.trim().split('-')
            return value[1]
        },
        capitalizec: function(value) {
            if (!value) return ''
            value = value.trim().split('-')
            return value[2]
        }
    },
    data() {
        return {
            policiesName: {
                name: '最新动态',
                englishName: 'News Center'
            },
            state: 11,
            limit: 5,
            dataList: [],
            NewsdataList: [],
            total: 0,
            value: true,
            bannerList: [],
            downList: []
        }
    },
    watch: {
        '$route.path': function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.state = this.$router.currentRoute.params.cId
            }
        }
    },
    mounted() {
        this.NewsDataRequest()
        this.dataDown()
    },
    beforeCreate() {
        document.querySelector('body').setAttribute(
            'style',
            'margin: 0 auto; width: 100%; background:rgba(244,245,247,1); overflow-x: hidden;height: 100%;')
    },
    methods: {
        dataDown() {
            this.$api.get('webInfo/formInfo', {
                params: {
                    limit: 5,
                    offset: 0
                }
            }).then(res => {
                this.downList = res.data.list
                this.total = res.data.count
            })
        },
        fallback() {
            this.$router.go(-1)
        },
        NewsDataRequest() {
            this.$api.get('news/xList', {
                params: {
                    cId: 1,
                    limit: 5,
                    offset: 0
                }
            }).then(res => {
                this.NewsdataList = res.data.list
            })
        },
        handleCurrentChange(val) {
            this.$api.get('webInfo/formInfo', {
                params: {
                    limit: this.limit,
                    offset: val - 1
                }
            }).then(res => {
                this.downList = res.data.list
                this.total = res.data.count
            })
        }
    }

}

</script>

<style lang="scss" scoped>
.main {
    background: rgba(244, 245, 247, 1);
    .case-container {
        width: 1920px;
        margin: 0 auto;
        position: relative;
        top: 0;
        font-size: 0;
        .bannar-box {
            width: 1920px;
            height: 360px;
        }
        .swiper-container {
            height: 100%;
            font-size: 0;
            .swiper-slide img {
                width: 100%;
                height: 100%;
                display: block;
                font-size: 0;
            }
            img {
                vertical-align: buttom;
                vertical-align: middle;
                vertical-align: top;
            }
            .swiper-slide { height: 10px; }
            .swiper-slide-active { height: auto; }
        }
        .new-list {
            position: absolute;
            top: 0;
            right: 380px;
            z-index: 99;
        }
        #map {
            width: 500px;
            height: 500px;
        }
    }
    .container {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .center-big-box {
            background-color: #fff;
            position: relative;
            margin-bottom: 60px;
            .center-box {
                width: 808px;
                height: 900px;
            }
            ::v-deep .el-pagination.is-background {
                .el-pager li:not(.disabled).active {
                    background-color: #243db3;
                }
            }
            .block {
                width: 100%;
                position: absolute;
                bottom: 60px;
                ::v-deep .el-pagination {
                    width: 634px;
                    margin: 0 auto;
                    li {
                        background-color: #fff;
                    }
                }
                ::v-deep .btn-next,
                ::v-deep .btn-prev {
                    background-color: #fff;
                }
            }
            ul {
                list-style: none;
                padding: 0 40px;
                margin-top: 0;
                margin-bottom: 90px;
                li {
                    width: 728px;
                    border-bottom: 1px solid rgba(242, 242, 242, 1);
                    display: flex;
                    justify-content: space-between;
                    padding: 20px 0 20px 0;
                    align-items: center;
                    .downBtn {
                        width: 120px;
                        height: 40px;
                        text-align: center;
                        flex-grow: 2;
                        line-height: 40px;
                        font-size: 14px;
                        font-weight: 600;
                        border: 1px solid #ccc;
                        cursor: pointer;
                        a {
                            display: block;
                            width: 100%;
                            height: 100%;
                            color: #333;
                            text-decoration: none;
                        }
                        &:hover {
                            background-color: #243db3;
                            a {
                                color: #fff;
                            }
                        }
                    }
                    span {
                        display: block;
                        width: 180px;
                        font-size: 24px;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        line-height: 40px;
                        text-align: center;
                        flex-grow: 2;
                        i {
                            font-style: normal;
                            font-size: 16px;
                            font-weight: 400;
                            color: rgba(153, 153, 153, 1);
                            display: block;
                            top: 0;
                            line-height: 30px;
                        }
                    }
                    .title {
                        width: 80%;
                        flex-grow: 8;
                        padding-left: 20px;
                        h4 {
                            font-size: 20px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 1);
                            line-height: 90px;
                            margin: 0;
                        }
                        p {
                            font-size: 16px;
                            font-weight: 400;
                            color: rgba(153, 153, 153, 1);
                            line-height: 24px;
                            margin-top: 4px;
                            margin-bottom: 0;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                    }
                    &:last-child {
                        border: none;
                    }
                }
            }
        }
        .right-box {
            width: 372px;
            height: 348px;
            background: rgba(255, 255, 255, 1);
        }
    }
}
.mobileMain {
    .head {
        height: 60px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eee;
        img {
            width: 10px;
            height: 16px;
        }
        div {
            flex: 1;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            color: #000;
        }
    }
    ul {
        padding: 0 15px;
        li {
            list-style: none;
            padding: 20px 0;
            border-bottom: 1px solid rgba(242, 242, 242, 1);
            display: flex;
            justify-content: space-between;
            align-items: center;
            .downBtn {
                width: 80px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                font-size: 14px;
                font-weight: 600;
                border: 1px solid #ccc;
                cursor: pointer;
                a {
                    display: block;
                    width: 100%;
                    height: 100%;
                    color: #333;
                    text-decoration: none;
                }
                &:hover {
                    background-color: #243db3;
                    a {
                        color: #fff;
                    }
                }
            }
            .time {
                font-size: 14px;
                color: #999;
                margin-top: 10px;
            }
            .title {
                font-size: 18px;
                font-weight: 500;
                color: #1a1b1f;
            }
        }
    }
}
</style>
